var map = {
	"./arabic.json": 582,
	"./bulgarian.json": 583,
	"./czech.json": 584,
	"./denmark.json": 585,
	"./english.json": 586,
	"./finnish.json": 587,
	"./greek.json": 588,
	"./indonesian.json": 589,
	"./malay.json": 590,
	"./norwegian.json": 591,
	"./romanian.json": 592,
	"./slovakia.json": 593,
	"./swedish.json": 594
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2464;


//////////////////
// WEBPACK FOOTER
// ./src/locales/gameonz [A-Za-z0-9-_,\s]+\.json$/
// module id = 2464
// module chunks = 0